export const appDataTypes = {
    SHOW_USER_MENU: "SHOW_USER_MENU",
    HIDE_USER_MENU: "HIDE_USER_MENU",

    SHOW_ALERT_NOTIFICATION: "SHOW_ALERT_NOTIFICATION",
    HIDE_ALERT_NOTIFICATION: "HIDE_ALERT_NOTIFICATION",
}